import { Fragment, useRef } from "react";
import { Card, Col, Container, Row, Table } from "reactstrap";
import { InvoiceButtons } from "../Common/InvoiceButtons";
import { InvoiceAddressSection } from "./InvoiceAddressSection";
import { InvoiceDateSection } from "./InvoiceDateSection";
import { InvoiceHeadSection } from "./InvoiceHeadSection";
import { InvoiceTable } from "./InvoiceTable";
import { InvoiceTexSection } from "./InvoiceTexSection";

const Invoice2Container = () => {
  const contentRef = useRef<HTMLDivElement | null>(null);
  return (
    <Fragment>
      <Container className="invoice-2">
        <div ref={contentRef}>
          <Row>
            <Col sm="12">
              <Card className="p-4">
                <Table borderless>
                  <tbody>
                    <tr>
                      <InvoiceHeadSection />
                    </tr>
                    <tr>
                      <InvoiceDateSection />
                    </tr>
                    <tr>
                      <InvoiceAddressSection />
                    </tr>
                    <tr>
                      <InvoiceTable />
                    </tr>
                    <tr>
                      <InvoiceTexSection />
                    </tr>
                  </tbody>
                </Table>
              </Card>
            </Col>
          </Row>
        </div>
      </Container>
      <InvoiceButtons contentRef={contentRef} />
    </Fragment>
  );
};

export default Invoice2Container;
